import React, { useState, useEffect } from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

function IndicatorLamp(props) {
  let { gloablfilter, IND } = props;
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [allData, setAllData] = useState([]);

  const [checkOnOff, setcheckOnOff] = useState(false)
  const res_indicator_lamp = (data) => {
    if (data.length > 0) {
      const OnOff = isVehicleOnline(data?.[0]?.fields?.eventDateTime?.[0])
      setcheckOnOff(OnOff)
      setAllData(data)
    } else {
      setcheckOnOff(false)
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "real_time_fault_code/indicator_lamp", body: { filterdata: gloablfilter, IND }, }, res_indicator_lamp);
  }, [gloablfilter]);

  function isVehicleOnline(vehicleTimeString) {
    const now = new Date();
    const thirtyMinutesAgo = new Date(now.getTime() - 30 * 60 * 1000); // Subtract 30 minutes

    // Parse the vehicle time string (format: "YYYY-MM-DD HH:mm:ss")
    const [datePart, timePart] = vehicleTimeString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);

    // Create a Date object for the vehicle time
    const vehicleTime = new Date(year, month - 1, day, hour, minute, second);

    // Compare vehicle time with the threshold
    // return vehicleTime >= thirtyMinutesAgo ? "Vehicle is online" : "Vehicle is not online";
    return vehicleTime >= thirtyMinutesAgo ? true : false;
  }

  return (
    <>
      <div className="v-title boxDIC borderDownDIC p-0 indicator_lamp mb-3">
        <div className="titlebg boxTitleDIC pb-2 pt-2">Indicator Lamp</div>
        <div className="row align-items-center justify-content-center px-2">
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/High_System_Temp_${(allData?.[0]?.fields?.High_Temperature_indication?.[0] === 0) ? "G" : (allData?.[0]?.fields?.High_Temperature_indication?.[0] === 1) ? "O" : "R"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/High_System_Temp_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">High System Temp</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/HV_Battery_Charging_Status_${(allData?.[0]?.fields?.HV_Charge_Indication?.[0] === 0) ? "G" : (allData?.[0]?.fields?.HV_Charge_Indication?.[0] == 1) ? "F" : "O"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/HV_Battery_Charging_Status_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">HV Battery Charging Status</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/Charging_Type_${((allData?.[0]?.fields?.BMS_FC_Gun_Status?.[0] === 1 && allData?.[0]?.fields?.BMS_SC_Gun_Status?.[0] === 1)) ? "F"
                  : (allData?.[0]?.fields?.BMS_FC_Gun_Status?.[0] === 1 && allData?.[0]?.fields?.BMS_SC_Gun_Status?.[0] === 0) ? "F"
                    : (allData?.[0]?.fields?.BMS_FC_Gun_Status?.[0] === 0 && allData?.[0]?.fields?.BMS_SC_Gun_Status?.[0] === 1) ? "S"
                      : "G"
                  }.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/Charging_Type_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Charging Type</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/Low_Battery_Motor_Coolent_Level_${(allData?.[0]?.fields?.Coolant_low?.[0] === 0) ? "G" : "O"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/Low_Battery_Motor_Coolent_Level_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Low Battery/Motor Coolant Level</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/Service_Indicator_${(allData?.[0]?.fields?.Service_Indication?.[0] === 0) ? "G" : "O"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/Service_Indicator_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Service Indicator</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/EV_System_Fault_${(allData?.[0]?.fields?.EV_Fault_Indication?.[0] === 0) ? "G" : "R"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/EV_System_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">EV System Fault</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/Electric_Hazard_${(allData?.[0]?.fields?.Electric_Hazard?.[0] === 0) ? "G" : "R"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/Electric_Hazard_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Electric Hazard</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              <img src={`/assets/images_realTimeFaultCode/Connection_Status_${(checkOnOff) ? 'ON' : 'OFF'}.png`} width="40" height="40" />
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Connection Status</small>
              </p>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-content-center px-2">
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/DNRL_${((allData?.[0]?.fields?.DNRL?.[0] === 1) ? "O" : (allData?.[0]?.fields?.DNRL?.[0] === 2) ? "N" : (allData?.[0]?.fields?.DNRL?.[0] === 3) ? "R" : "L")}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/DNRL_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">DNRL</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/BMS_Fault_${((allData?.[0]?.fields?.BMS_Fault_Level?.[0] === 1) ? "R" : (allData?.[0]?.fields?.BMS_Fault_Level?.[0] === 2) ? "O" : "G")}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/BMS_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">BMS Fault</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/DCDC_Fault_${(allData?.[0]?.fields?.DCDC_hard_fault?.[0] === 1
                  || allData?.[0]?.fields?.DCDC_Communication_Error?.[0] === 1
                  || allData?.[0]?.fields?.DCDC_Stop_Error?.[0] === 1
                  || allData?.[0]?.fields?.DCDC_over_temperature?.[0] === 1) ? "O" : "G"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/DCDC_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">DCDC Fault</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/Motor_Fault_${(allData?.[0]?.fields?.MCU_LimpHomeMode?.[0] === 1 && (
                  allData?.[0]?.fields?.MCU_5V_Supply_Failure?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Controller_Overcurrent?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Current_Sensor_Fault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_DigitalOut6OpenorShort?.[0] === 0
                  || allData?.[0]?.fields?.MCU_DigitalOut7OpenorShort?.[0] === 0
                  || allData?.[0]?.fields?.MCU_DriverSupply?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Encoder_Fault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_EncoderPulseCountFault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_HPD_or_Sequencing_Fault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Main_Contactor_DidNot_Close?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Main_Contactor_Welded?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Motor_Open?.[0] === 0
                  || allData?.[0]?.fields?.MCU_MotorCharacterizationFault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_MotorTypeFault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_OS_General?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Reset_DefinedFaults?.[0] === 0
                  || allData?.[0]?.fields?.MCU_SevBpositiveUndervoltage?.[0] === 0
                  || allData?.[0]?.fields?.MCU_SevereBpos_Overvolt?.[0] === 0
                  || allData?.[0]?.fields?.MCU_SevereKSIUndervoltage?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Supervisory_Fault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_SupervisorIncompatible?.[0] === 0
                  || allData?.[0]?.fields?.MCU_VCL_or_OSMismatch?.[0] === 0
                  || allData?.[0]?.fields?.MCU_BPostiveOvervoltageCutback?.[0] === 0
                  || allData?.[0]?.fields?.MCU_EmerRevHPD?.[0] === 0
                  || allData?.[0]?.fields?.MCU_EmerRevTimeout?.[0] === 0
                  || allData?.[0]?.fields?.MCU_PDO_Timeout?.[0] === 0
                  || allData?.[0]?.fields?.MCU_PDOpenorShort?.[0] === 0
                  || allData?.[0]?.fields?.MCU_CAN_Enable_Fault?.[0] === 0
                  || allData?.[0]?.fields?.MCU_Communication_Fault?.[0] === 0
                )
                ) ? "O" : (
                  allData?.[0]?.fields?.MCU_5V_Supply_Failure?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Controller_Overcurrent?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Current_Sensor_Fault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_DigitalOut6OpenorShort?.[0] === 1
                  || allData?.[0]?.fields?.MCU_DigitalOut7OpenorShort?.[0] === 1
                  || allData?.[0]?.fields?.MCU_DriverSupply?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Encoder_Fault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_EncoderPulseCountFault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_HPD_or_Sequencing_Fault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Main_Contactor_DidNot_Close?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Main_Contactor_Welded?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Motor_Open?.[0] === 1
                  || allData?.[0]?.fields?.MCU_MotorCharacterizationFault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_MotorTypeFault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_OS_General?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Reset_DefinedFaults?.[0] === 1
                  || allData?.[0]?.fields?.MCU_SevBpositiveUndervoltage?.[0] === 1
                  || allData?.[0]?.fields?.MCU_SevereBpos_Overvolt?.[0] === 1
                  || allData?.[0]?.fields?.MCU_SevereKSIUndervoltage?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Supervisory_Fault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_SupervisorIncompatible?.[0] === 1
                  || allData?.[0]?.fields?.MCU_VCL_or_OSMismatch?.[0] === 1
                  || allData?.[0]?.fields?.MCU_BPostiveOvervoltageCutback?.[0] === 1
                  || allData?.[0]?.fields?.MCU_EmerRevHPD?.[0] === 1
                  || allData?.[0]?.fields?.MCU_EmerRevTimeout?.[0] === 1
                  || allData?.[0]?.fields?.MCU_PDO_Timeout?.[0] === 1
                  || allData?.[0]?.fields?.MCU_PDOpenorShort?.[0] === 1
                  || allData?.[0]?.fields?.MCU_CAN_Enable_Fault?.[0] === 1
                  || allData?.[0]?.fields?.MCU_Communication_Fault?.[0] === 1
                ) ? "R" : "G"
                  }.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/Motor_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">Motor Fault</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/OBC_Fault_${(allData?.[0]?.fields?.OBC_Hardware_Failure?.[0] === 0) ? "G" : "O"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/OBC_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">OBC Fault</small>
              </p>
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 m-auto">
            <div className="align-items-center">
              {(checkOnOff) ?
                <img src={`/assets/images_realTimeFaultCode/BCS_Fault_${(allData?.[0]?.fields?.BCS_Fault_code?.[0] === 0) ? "G" : "O"}.png`} width="40" height="40" />
                :
                <img src={`/assets/images_realTimeFaultCode/BCS_Fault_G.png`} width="40" height="40" />
              }
            </div>
            <div className="text-center">
              <p className="m-0 lh-1" style={{ fontSize: "70%" }}>
                <small className="text-muted">BSC Fault</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IndicatorLamp;